function getBasename() {
    let publicPathFromEnv = process.env.PUBLIC_PATH;
    if (!publicPathFromEnv) {
        return '/';
    }
    if (!publicPathFromEnv.startsWith('/')) {
        publicPathFromEnv = `/${publicPathFromEnv}`;
    }
    if (!publicPathFromEnv.endsWith('/')) {
        publicPathFromEnv = `${publicPathFromEnv}/`;
    }
    return publicPathFromEnv;
}
/**
 * Returns true if viewing a game info page at its direct URL (rather than inside the single-page application).
 */
export function isGameGuidePath() {
    const { pathname } = new URL(location.href);
    return pathname.startsWith(`${getBasename()}guide`);
}
